import { IDealerCenterAddress } from '@/types/dealers';

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function uniq(array: string[]) {
  return [...new Set(array)];
}

export function formatPhone(phone?: string) {
  if (phone) {
    return phone?.replace(/[^+\d]/g, '');
  }
  return '';
}

export function prettifyPhone(phone?: string) {
  if (phone) {
    return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 ($2) $3-$4-$5');
  }
  return '';
}

export function formatDate(date: Date | string) {
  const resolvedDate = new Date(date);

  const formatter = new Intl.DateTimeFormat('ru');

  return formatter.format(resolvedDate);
}

export function formatAddress(address: IDealerCenterAddress) {
  const { streetTypeFull, street, house, flatTypeFull, flat } = address;
  const parts = [];

  parts.push(`${streetTypeFull ? `${streetTypeFull} ` : ''}${street}`.trim());

  parts.push(house);

  if (flatTypeFull && flat) {
    parts.push(`${flatTypeFull} ${flat}`);
  }

  return parts.join(', ').trim();
}

export function isExist<T = any>(value: T, array: T[]) {
  return array.find(v => v === value);
}

export function formatPrice(price: number) {
  const formatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  });
  return formatter.format(price);
}
